"use client";

import React, { useState } from "react";
import { useRef, useEffect } from "react";

import { Autoplay, FreeMode, Navigation, Pagination } from "swiper/modules";
import Reviewscard from "../cards/reviews-card/reviewscard";
import { ReviewDetailsList } from "@packages/lib/types/interfaces";
import { getArticleDetailUrlParamValues } from "@packages/lib/utlils/helper-function";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import dynamic from "next/dynamic";
import { SwiperSlide, Swiper } from "swiper/react";
import { GA4DataLayer } from "@packages/lib/utlils/helper-function";
import { GAConstants } from "@packages/shared-components/services/constants";
// const Swiper = dynamic(() => import("swiper/react").then((mod) => mod.Swiper), {
//   ssr: false,
// });
// const SwiperSlide = dynamic(
//   () => import("swiper/react").then((mod) => mod.SwiperSlide),
//   { ssr: false }
// );

const DetailedReviewLightBox = dynamic(
  () =>
    import(
      "@packages/shared-components/common-utilities/modal/review-lightbox/DetailedReviewLightBox"
    ),
  {
    ssr: false,
  },
);
interface ReviewSliderProps {
  reviewData: ReviewDetailsList["reviewDetail"];
  pageName?: any;
  parent_category?: any;
  sub_Category?: any;
  commonGAAttrs?: any;
  heading?: any;
  rev_CardCount?: any;
  rev_className?: any;
  autoplay?: any;
  rev_Navigation?: any;
  hideReadMore?: any;
  mobileSpaceBetween?: any;
  cardClassName?: string;
  commonOldGAAttrs?: any;
}

const Reviewslidercomponents: React.FC<ReviewSliderProps> = ({
  reviewData,
  pageName,
  parent_category,
  sub_Category,
  commonGAAttrs,
  heading,
  commonOldGAAttrs,
  rev_CardCount = 3,
  rev_className = "",
  autoplay = false,
  rev_Navigation = true,
  hideReadMore = false,
  mobileSpaceBetween = 8,
  cardClassName,
}) => {
  const { category, subCategory, articleTitle } =
    getArticleDetailUrlParamValues();
  const [openedReviewId, setOpenedReviewId] = useState<null | number>(null);

  const handleReviewLightBox = (event: any, review: any) => {
    event.stopPropagation();
    setOpenedReviewId(() => review?.reviewId);
  };
  const swiperRef = useRef<any>(null);
  const isPaginationClick = useRef(false);
  const handleSlide = () => {
    if (!isPaginationClick.current) {
      GA4DataLayer({
        event: GAConstants.track_event,
        event_name: "carousel_navigation",
        click_text: heading,
        // field:"arrow"
        navigation_category: "arrow",
        ...commonGAAttrs,
      });
    }
  };
  const handleSwiperInit = (swiper: any) => {
    swiperRef.current = swiper;

    // Add click listeners to pagination bullets
    setTimeout(() => {
      const bullets = document.querySelectorAll(
        ".MultiSwiper .swiper-pagination-bullet",
      );
      bullets.forEach((bullet) => {
        bullet.addEventListener("click", () => {
          isPaginationClick.current = true;
          GA4DataLayer({
            event: GAConstants.track_event,
            event_name: "carousel_navigation",
            click_text: heading,
            // field:"arrow"
            navigation_category: "dot",
            ...commonGAAttrs,
          });
          setTimeout(() => {
            isPaginationClick.current = false;
          }, 100);
        });
      });
    }, 100);
  };
  return (
    <>
      <div className="slider-container" data-testid="review-slider">
        <Swiper
          onSwiper={handleSwiperInit}
          onSlideNextTransitionStart={handleSlide}
          onSlidePrevTransitionStart={handleSlide}
          pagination={{ clickable: true }}
          navigation={rev_Navigation}
          autoplay={
            autoplay
              ? {
                  delay: 10000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }
              : false
          }
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: mobileSpaceBetween,
            },
            768: {
              slidesPerView: rev_CardCount ? rev_CardCount : 2,
              spaceBetween: 10,
            },
            1200: {
              slidesPerView: rev_CardCount ? rev_CardCount : 3,
              spaceBetween: 20,
            },
          }}
          modules={[FreeMode, Pagination, Navigation, Autoplay]}
          className={`MultiSwiper ${reviewData.length <= 3 ? (reviewData.length < 2 ? "singleReview" : "multiReview") : ""} ${rev_className || ""}`}
        >
          {reviewData &&
            reviewData?.map((review, index) => (
              <SwiperSlide key={index}>
                <Reviewscard
                  reviewData={review}
                  index={index}
                  ratings={5}
                  pageName={pageName}
                  article_category={category ? category : parent_category}
                  article_subCat={subCategory ? subCategory : sub_Category}
                  handleReviewLightBox={handleReviewLightBox}
                  commonGAAttrs={commonGAAttrs}
                  commonOldGAAttrs={commonOldGAAttrs}
                  hideReadMore={hideReadMore}
                  cardClassName={cardClassName}
                />
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
      {openedReviewId && (
        <DetailedReviewLightBox
          reviewId={openedReviewId}
          closeModal={() => setOpenedReviewId(() => null)}
        />
      )}
    </>
  );
};

export default Reviewslidercomponents;
